<h1
	*ngIf="stepIndex() === 0"
	matDialogTitle
>
	<div class="flex flex-row items-center justify-start">
		<div>{{ 'time.pick-project' | translate }}</div>
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</h1>
<tg-plain-stepper
	[(selectedIndex)]="stepIndex"
	class="relative h-full overflow-hidden"
>
	<cdk-step>
		<tg-project-list
			(entityChange)="onSelectProject($event)"
			[selectedEntity]="entityData"
			[suggestProjectByName]="createData?.title"
			[userId]="createData?.user?.id"
			class="max-h-inherit"
			showNextItemIcon
		></tg-project-list>
	</cdk-step>
	<cdk-step>
		<app-time-tracker-calendar-create-dialog [data]="createData"></app-time-tracker-calendar-create-dialog>
	</cdk-step>
</tg-plain-stepper>

<mat-dialog-actions
	*ngIf="stepIndex() === 0"
	align="end"
	class="mx-8 !mb-0 flex items-center space-x-4"
>
	<button
		(click)="createProject()"
		*ngIf="project$canManage | async"
		mat-button
	>
		{{ 'project.create' | translate }}
	</button>
	<button
		(click)="onSelectProject()"
		color="primary"
		mat-raised-button
	>
		Next
	</button>
</mat-dialog-actions>
